import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { OrganizationsTable } from "./components/tables/OrganizationsTable";

const AdminOrganizations = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Organizations");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Organizations" },
        ]);
    });

    return (
        <AdminPageContent>
            <OrganizationsTable />
        </AdminPageContent>
    );
};

export default AdminOrganizations;
